<template>
    <div class="parent">
        <div v-for="file in files" :key="file.id" class="file-container mx-1">
            <button v-if="canEdit" type="button" class="btn btn-light btn-sm text-danger remove-icon" :aria-label="'Убрать файл ' + file.originalName" @click="onRemoveClick(file)"><i class="fas fa-times" aria-hidden="true" /></button>
            <div class="d-flex justify-content-center align-items-center" @click="() => onContainerClick(file)">
                <img v-if="file.isImage" :src="file.url" :alt="file.originalName">
                <i v-else :class="file.iconClass"></i>
            </div>
            <div class="link-text">
                <a :href="file.url" target="_blank" class="small" :title="file.originalName" @click="handleFileLinkClick($event, file)">
                    {{ file.originalName }}
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import {
    fileIconClass as getFileIconClass,
    isImageFile as isViewerImageFile,
    withQueryParams
} from '@/utils/fileViewer';

export default {
    name: "FileList",
    computed: {
        files() {
            const {list, $store} = this;
            return list.map(el => {
                const url = el.url && !el.url.includes('gjuid=')
                    ? withQueryParams(el.url, {gjuid: $store.state.token})
                    : el.url;

                return {
                    ...el,
                    url,
                    isImage: this.isImageFile(el),
                    iconClass: getFileIconClass(el),
                    raw: el
                };
            })
        },
        viewerFiles() {
            return this.files.map(file => ({
                id: file.id,
                name: file.originalName || file.file_name || file.name || `Файл`,
                url: file.url,
                downloadUrl: file.url,
                thumbnailUrl: file.isImage ? file.url : null,
                mimeType: file.mimeType || file.mime_type,
                size: file.file_size || file.size,
                isImage: file.isImage,
                raw: file.raw || file
            }));
        },
    },
    props: {
        list: Array,
        canEdit: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        isImageFile(file) {
            return isViewerImageFile(file);
        },
        onContainerClick(file) {
            this.openFileViewer(file);
        },
        openFileViewer(file) {
            if (!file) {
                return;
            }
            if (!this.$fileViewer) {
                window.open(file.url, '_blank');
                return;
            }
            this.$fileViewer.open(this.viewerFiles, {
                startId: file.id,
                source: `task-files`
            });
        },
        handleFileLinkClick(event, file) {
            if (event && event.preventDefault) {
                event.preventDefault();
            }
            this.openFileViewer(file);
        },
        onRemoveClick(file) {
            this.$bvModal.msgBoxConfirm(`Убрать файл «${file.originalName}» из вложений?`, {
                title: 'Вложение', okTitle: 'Убрать файл', okVariant: 'danger', contentClass: 'argus-glass-dialog', cancelTitle: `Отмена`
            })
                .then(confirm => {
                    if (confirm) {
                        this.$emit(`remove`, file.id);
                    }
                })
        }
    }
}
</script>

<style lang="scss" scoped>
.parent {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}

.file-container {
  width: 100px;
  height: auto;
  text-align: center;
  position: relative;

  .remove-icon {
    position: absolute;
    right: 0;
  }

  .remove-icon:hover {
    font-size: 100%;
  }

  img {
    width: 100%;
    height: auto;
    margin: 0;
  }

  .fa-file {
    font-size: 40px;
  }

  .link-text {
    a {
      display: block; /* or inline-block */
      text-overflow: ellipsis;
      word-wrap: break-word;
      overflow: hidden;
      max-height: 1.8em;
      line-height: 1.8em;
    }
  }

}
</style>
